import { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
} from "@mui/material";
import PageTitle from "../../molecules/PageTitle";
import DoorBasicSettings from "./DoorBasicSettings";
import { useParams } from "react-router-dom";
import { getJwtTokenFromIdToken } from "../auth/AuthFanc";
import { CustomContainer } from "../../../styles/styles";
import NavigateButton from "../../atoms/Button/NavigateButton";

export type SciOptionalBehaviorType = "OFF" | "ON_WHEN_REQUESTED" | "ALWAYS_ON";

export type SignageContents = {
  autoSciUserTypeId: number;
  contentIdentifier: string;
}[];

export interface SocialDoorData {
  autoSdcId: number;
  sdcUuid: string;
  sdcSerialNumber: string;
  doorPlace: string;
  sciGuideBellBehavior: SciOptionalBehaviorType;
  sciGuideBellOpenBehavior: SciOptionalBehaviorType;
  sciProximityOpenBehavior: SciOptionalBehaviorType;
  sciSpeakerBehavior: SciOptionalBehaviorType;
  sciHelpOk: string;
  building: {
    autoBuildingId: number;
    buildingName: string;
  };
  sciSignageContents: SignageContents;
  isGuideBellEnabled: boolean;
  isSpeakerEnabled: boolean;
}

const DoorSettingsPage = () => {
  const { autoBuildingId, autoSdcId } = useParams();
  const [doorData, setDoorData] = useState<SocialDoorData | undefined>(
    undefined
  );

  // API呼び出しをここで行う
  useEffect(() => {
    // 内部の非同期関数を定義
    const fetchData = async () => {
      // JWTトークンを取得します
      const jwtToken = await getJwtTokenFromIdToken();

      try {
        // call showSdcWithAutoBuildingId API
        const response = await fetch(
          process.env.REACT_APP_API_ENDPOINT +
            `/buildings/${autoBuildingId}/sdcs/${autoSdcId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: jwtToken,
            },
          }
        );

        const data = await response.json();
        setDoorData(data);
        console.log("API取得データ" + JSON.stringify(data));
      } catch (error) {
        console.error(error);
      }
    };

    // 非同期関数を実行
    fetchData();
  }, [autoBuildingId, autoSdcId]);

  return (
    <CustomContainer maxWidth="xl">
      <Grid item xs={12} marginBottom={3}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <PageTitle title="ドア詳細設定" />
          <NavigateButton
            to={"/buildings/" + autoBuildingId + "/doors"}
            buttonTitle={"管理ドア一覧"}
          />
        </Box>
      </Grid>
      {/* ドア基本情報 */}
      <Box display="flex" justifyContent="space-between" alignItems="flex-end">
        <Box>
          <TableContainer>
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell component="th" scope="row">
                    SDC SN:
                  </TableCell>
                  <TableCell>{doorData?.sdcSerialNumber || ""}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    建物名称:
                  </TableCell>
                  <TableCell>{doorData?.building.buildingName || ""}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    設置場所:
                  </TableCell>
                  <TableCell>{doorData?.doorPlace || ""}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8} marginTop={4}>
          {/* TODO: ドアの基本設定 */}
          <DoorBasicSettings doorData={doorData} />
        </Grid>
        <Grid item xs={12} md={8} marginTop={4}>
          {/* TODO: ドアのその他の設定 */}
          {/* <DoorScheduleSettings doorData={doorData} />{" "} */}
        </Grid>
      </Grid>
    </CustomContainer>
  );
};

export default DoorSettingsPage;
